import clsx from 'clsx';

import { Chips, type ChipsProps } from '../../ui/chips';
import type { InputProps } from '../../ui/input';
import { Input } from '../../ui/input';
import * as styles from './share.css';
export type AuthInputProps = InputProps & {
  label?: string;
  error?: boolean;
  errorHint?: string;
  classNameRoot?: string;
  classNameHint?: string;
  withoutHint?: boolean;
  onEnter?: () => void;
  multiple?: boolean;
  listItems?: ChipsProps['listItems'];
  setListItems?: ChipsProps['setListItems'];
};
export const AuthInput = ({
  label,
  error,
  errorHint,
  withoutHint = false,
  onEnter,
  className,
  classNameRoot,
  classNameHint,
  multiple,
  listItems,
  setListItems,
  ...inputProps
}: AuthInputProps) => {
  return (
    <div
      className={clsx(classNameRoot, styles.authInputWrapper, {
        'without-hint': withoutHint,
      })}
    >
      {label ? <label>{label}</label> : null}
      <Input
        className={clsx(className)}
        size="extraLarge"
        status={error ? 'error' : 'default'}
        onEnter={onEnter}
        multiple={multiple}
        chips={
          listItems?.length ? (
            <Chips listItems={listItems} setListItems={setListItems} />
          ) : null
        }
        {...inputProps}
      />
      {error && errorHint && !withoutHint ? (
        <div
          className={clsx(styles.formHint, classNameHint, {
            error: error,
          })}
        >
          {errorHint}
        </div>
      ) : null}
    </div>
  );
};
